export default __webpack_public_path__ + "static/media/gallery_13.013b5094.jpg";